import request from "../../utils/request";

export const fetchNewMessage = () => {
  return request.post("/supply/member/message/new");
};
